import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
} from '@mui/material';
import {
  Download,
  ArrowBack,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const CapabilityStatementPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #1e3a8f 0%, #3b82f6 100%)',
          color: 'white',
          pt: 12,
          pb: 8,
        }}
      >
        <Container maxWidth="lg">
          <Button
            startIcon={<ArrowBack />}
            onClick={() => navigate(-1)}
            sx={{ color: 'white', mb: 2 }}
          >
            Back
          </Button>
          <Typography variant="h1" gutterBottom sx={{ fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
            Capability Statement
          </Typography>
          <Typography variant="h5" sx={{ opacity: 0.95 }}>
            Intellusia Studios LLC - Government Contractor Capabilities
          </Typography>
        </Container>
      </Box>

      {/* PDF Viewer Section */}
      <Box sx={{ py: 4 }}>
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <Button
              variant="contained"
              startIcon={<Download />}
              href="/Intellusia Studios Capability Statement_Working_Copy.docx.pdf"
              download="Intellusia_Studios_Capability_Statement.pdf"
            >
              Download PDF
            </Button>
          </Box>

          <Paper elevation={3}>
            <Box
              sx={{
                width: '100%',
                height: '80vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <iframe
                src="/Intellusia Studios Capability Statement_Working_Copy.docx.pdf"
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                title="Capability Statement"
              />
            </Box>
          </Paper>

          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              If the PDF doesn't display, you can{' '}
              <a
                href="/Intellusia Studios Capability Statement_Working_Copy.docx.pdf"
                download="Intellusia_Studios_Capability_Statement.pdf"
                style={{ color: 'inherit', textDecoration: 'underline' }}
              >
                download it here
              </a>
              .
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default CapabilityStatementPage;
